import { Injectable, Inject } from '@angular/core';
import { Headers, RequestOptions, Response } from '@angular/http';
import { Messaggio, StaticUrls } from '../models';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { tokenNotExpired, AuthHttp } from 'angular2-jwt';
import { MyCookieService } from './my-cookie.service';
import { environment } from 'environments/environment';

@Injectable()
export class MessaggioService {
	private headers = new Headers({ 'Content-Type': 'application/json' });
	private options = new RequestOptions({ headers: this.headers });

	constructor(private http: AuthHttp,
		@Inject(MyCookieService) private myCookieService: MyCookieService,
		private router: Router) { }

	post(messaggio: Messaggio) {
		if (this.myCookieService.token) {
			if (this.ifTokenExpired()) {
				return this.http.post(StaticUrls._messaggio, JSON.stringify(messaggio), this.options)
					.map(response => { return response; })
					.catch(this.handleError);
			}
		}
	}

	postPrenotazione(messaggio: Messaggio) {
		if (this.myCookieService.token) {
			if (this.ifTokenExpired()) {
				return this.http.post(StaticUrls._messaggio_prenotazione, JSON.stringify(messaggio), this.options)
					.map(response => { return response; })
					.catch(this.handleError);
			}
		}
	}

	postConferma(messaggio: Messaggio) {
		if (this.myCookieService.token) {
			if (this.ifTokenExpired()) {

				return this.http.post(StaticUrls._messaggio_conferma, JSON.stringify(messaggio), this.options)
					.map(response => { return response; })
					.catch(this.handleError);
			}
		}
	}

	postCheckLetto(id: number) {
		if (this.myCookieService.token) {
			if (this.ifTokenExpired()) {
				return this.http.post(StaticUrls._msgCheckLetto(id), {}, this.options)
					.map(response => { return response; })
					.catch(this.handleError);
			}
		}
	}

	postArchivia(messaggi: Array<Messaggio>) {
		if (this.myCookieService.token) {
			if (this.ifTokenExpired()) {
				return this.http.post(StaticUrls._msg_archivia, JSON.stringify(messaggi), this.options)
					.map(response => { return response; })
					.catch(this.handleError);
			}
		}
	}

	count(letto: boolean) {
		if (this.myCookieService.token) {
			if (this.ifTokenExpired()) {
				return this.http.get(StaticUrls._msgCount(letto), this.options)
					.map(this.extractData)
					.catch(this.handleError);
			}
		}
	}

	getUltimiNonLetti() {
		if (this.myCookieService.token) {
			if (this.ifTokenExpired()) {

				return this.http.get(StaticUrls._short_nl, this.options)
					.map(this.extractData)
					.catch(this.handleError);
			}
		}
	}

	getRicevuti() {
		if (this.myCookieService.token) {
			if (this.ifTokenExpired()) {

				return this.http.get(StaticUrls._ricevuti, this.options)
					.map(this.extractData)
					.catch(this.handleError);
			}
		}
	}

	getInviati() {
		if (this.myCookieService.token) {
			if (this.ifTokenExpired()) {

				return this.http.get(StaticUrls._inviati, this.options)
					.map(this.extractData)
					.catch(this.handleError);
			}
		}
	}

	getArchiviati() {
		if (this.myCookieService.token) {
			if (this.ifTokenExpired()) {

				return this.http.get(StaticUrls._archiviati, this.options)
					.map(this.extractData)
					.catch(this.handleError);
			}
		}
	}

	private extractData(res: Response) {
		return res.json();
	}

	private handleError(error: Response | any) {
		let errMsg: string;

		if (error instanceof Response) {
			const body = error.json() || '';
			const err = body.error || JSON.stringify(body);
			errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
			if (error.status == 401) {
				this.router.navigate(['login']);
			}
		} else {
			errMsg = error.message ? error.message : error.toString();
		}

		return Observable.throw(errMsg);
	}

	private ifTokenExpired() {
		if (this.myCookieService.token) {
			if (!tokenNotExpired(environment.tokenName)) {
				this.router.navigate(['login']);
				return false;
			} else {
				return true;
			}
		} else {
			return false;
		}
	}
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/messaggio.service.ts